import { render, staticRenderFns } from "./setRole.vue?vue&type=template&id=4c3a670c&"
import script from "./setRole.vue?vue&type=script&lang=ts&"
export * from "./setRole.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports